import React from "react";
import { Link } from "react-router-dom";
import service1 from "../resources/service1.png";
import service2 from "../resources/service2.png";
import service3 from "../resources/service3.png";
import service4 from "../resources/service4.png";

function AboutPage() {
  const info = [
    {
      title: "full auto service",
      description: "We work with quality and attention to detail.",
      image: service1,
    },
    {
      title: "customer service",
      description: "We offer an excellent customer service.",
      image: service2,
    },
    {
      title: "Efficiency",
      description: "We work fast and efficiently.",
      image: service3,
    },
    {
      title: "Affordable",
      description: "Best bang for the buck.",
      image: service4,
    },
  ];

  return (
    <main className="bg-white">
      {/* Hero header */}
      <section className="relative bg-zinc-950 text-white overflow-hidden">
        <div className="absolute inset-0 bg-grid-pattern bg-[size:50px_50px] opacity-[0.08]"></div>
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-brand-500/15 rounded-full blur-3xl -translate-x-1/3 -translate-y-1/3"></div>

        <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-20 md:pt-28 pb-20 md:pb-28">
          <span className="reveal text-brand-400 font-dancing text-3xl md:text-4xl block mb-2">
            About
          </span>
          <h1 className="reveal reveal-delay-1 font-chivo text-5xl md:text-7xl lg:text-8xl font-black leading-[0.95] tracking-tight">
            Bini Autorepair{" "}
            <span className="gradient-text">INC</span>
          </h1>
        </div>
      </section>

      {/* Story */}
      <section className="max-w-5xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid md:grid-cols-5 gap-10 md:gap-16">
          <div className="md:col-span-2">
            <div className="sticky top-32">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-500/10 text-brand-700 text-xs font-semibold uppercase tracking-[0.2em] mb-5">
                Our Story
              </div>
              <h2 className="font-chivo font-black text-3xl md:text-4xl text-zinc-900 leading-tight tracking-tight">
                25+ years of trusted auto care in{" "}
                <span className="gradient-text">NYC</span>
              </h2>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="font-montserrat text-zinc-600 text-base md:text-lg leading-relaxed">
              Welcome to{" "}
              <span className="font-bold text-brand-700">
                Bini Autorepair INC
              </span>
              , your trusted auto repair shop in New York City. With over{" "}
              <span className="font-bold text-brand-700">25</span> years of
              experience, we have been providing exceptional service to our
              customers. Our team of skilled technicians is dedicated to
              delivering prompt, efficient, and high-quality workmanship on
              every job. At Bini Autorepair INC , we prioritize customer
              satisfaction and strive to exceed your expectations with
              personalized service tailored to your needs. With extensive
              experience across all areas of the auto industry, we have earned
              a reputation as the go-to destination for automotive services.
              Customers from all boroughs choose us for our outstanding service
              and attention to detail. Conveniently located at{" "}
              <span className="font-bold text-brand-700">
                10 Eastman Pl, Yonkers, NY 10701
              </span>
              , Bini Autorepair INC is your one-stop shop for all your auto
              repair needs. Trust us to provide top-notch service and get you
              back on the road safely.
            </p>
          </div>
        </div>
      </section>

      {/* Values grid */}
      <section className="bg-gradient-to-b from-zinc-50 to-white py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="text-center mb-14 md:mb-20 max-w-2xl mx-auto">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-brand-500/10 text-brand-700 text-xs font-semibold uppercase tracking-[0.2em] mb-5">
              Why Choose Us
            </div>
            <h2 className="font-chivo font-black text-3xl md:text-5xl text-zinc-900 leading-tight tracking-tight">
              What makes us{" "}
              <span className="gradient-text">different</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {info.map((item, idx) => (
              <div
                key={item.title}
                className="group relative p-8 rounded-3xl bg-white border border-zinc-200/80 shadow-soft hover:shadow-xl hover:-translate-y-1 hover:border-brand-500/40 transition-all"
              >
                <span className="absolute top-6 right-6 text-zinc-200 text-3xl font-black select-none">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-brand-500 to-brand-800 flex items-center justify-center mb-5 shadow-glow group-hover:scale-110 transition-transform">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-7 h-7"
                    style={{ filter: "brightness(0) invert(1)" }}
                  />
                </div>
                <h3 className="uppercase font-bold font-chivo text-zinc-900 text-base md:text-lg tracking-wide">
                  {item.title}
                </h3>
                <p className="text-zinc-500 font-montserrat mt-2 text-sm md:text-base leading-relaxed">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-28">
        <div className="max-w-5xl mx-auto px-6 md:px-10">
          <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-brand-600 to-brand-900 p-10 md:p-16 text-white text-center">
            <div className="absolute inset-0 bg-grid-pattern bg-[size:30px_30px] opacity-20"></div>
            <div className="relative">
              <h2 className="font-chivo font-black text-3xl md:text-5xl leading-tight tracking-tight">
                Ready to experience the difference?
              </h2>
              <p className="mt-4 text-white/80 font-montserrat text-base md:text-lg">
                Get in touch with our team — no appointment required.
              </p>
              <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
                <a href="tel:+13475820864">
                  <button className="rounded-full px-8 py-4 bg-white text-brand-700 font-bold hover:bg-zinc-100 hover:scale-105 transition-all shadow-xl">
                    <span className="flex items-center gap-3">
                      <i className="fa-solid fa-phone"></i>
                      Call (347) 582-0864
                    </span>
                  </button>
                </a>
                <Link to="/contact">
                  <button className="rounded-full px-8 py-4 bg-white/10 backdrop-blur border border-white/20 text-white font-bold hover:bg-white/20 transition-all">
                    Contact Us
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AboutPage;
